import { useState } from 'react'
import { Input } from '../ui/Input'
import { Button } from '../ui/Button'

interface RegistrationFormProps {
  onSubmit: (data: { email: string; password: string; username: string }) => Promise<void>
  loading: boolean
}

export function RegistrationForm({ onSubmit, loading }: RegistrationFormProps) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [username, setUsername] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    await onSubmit({ email, password, username })
  }

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <Input
        label="Nom d'utilisateur"
        id="username"
        type="text"
        required
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />

      <Input
        label="Email"
        id="email"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <Input
        label="Mot de passe"
        id="password"
        type="password"
        required
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <Button
        type="submit"
        isLoading={loading}
        loadingText="Inscription en cours..."
      >
        S'inscrire
      </Button>
    </form>
  )
}